import React, { useEffect, useState } from "react";
import { College } from "../College";
import SwiperCore, { Autoplay, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Link } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";

SwiperCore.use([Autoplay, Pagination]);
export const College_Section = () => {
  const [collegeData, setCollegeData] = useState([]);
  const sortDataByRating = (a, b) => {
    if (a.rating < b.rating) {
      return 1;
    } else if (a.rating > b.rating) {
      return -1;
    }
    return 0;
  };
  function fetchData() {
    fetch("/data.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        let newArray = data.colleges.sort(sortDataByRating);
        newArray = newArray.filter((item, index) => index < 5);
        setCollegeData(newArray);
      })
      .catch((e) => console.log("Error reading data", e.message));
  }
  useEffect(() => {
    fetchData();
    return () => {
      // eslint-disable-next-line
    };
  }, []);
  return (
    <div className="container colleges-section">
      <div className="colleges mt-5">
        <h1 className="section-title text-center fw-500">
          Best <span className="text-sans">{collegeData.length}</span> Bsc.CSIT
          Colleges
        </h1>
        <div className="mt-5 py-5">
          {collegeData.length === 0 ? (
            <div className="flex jc-c ai-c">
              <CircularProgress color="black" />
            </div>
          ) : (
            <Swiper
              loop
              slidesPerView={1}
              autoplay={{
                delay: 1500,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
                type: "bullets",
              }}
              spaceBetween={0}
              centeredSlides={false}
              breakpoints={{
                500: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                },
                600: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                850: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
            >
              {collegeData.map((college, index) => (
                <SwiperSlide key={index}>
                  <College
                    name={college.college_name}
                    location={college.location}
                    website={college.website}
                    logo={college.logo}
                    type={college.type}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          )}

          <div className="flex my-3 jc-sb">
            <div></div>
            <div>
              <Link to="/college-list/all" className="link btn btn-md btn-blue">
                View all College List
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
